import { api } from "@/lib/api";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old cuid URL, kept so bookmarks land on `/work-item/:globalId`. */
export const Route = createFileRoute("/_app/work-items/$id")({
  loader: async ({ params }) => {
    const { globalId } = await api.get<{ globalId: number }>(`/api/work-items/${params.id}`);
    throw redirect({ to: "/work-item/$id", params: { id: String(globalId) }, replace: true });
  },
});
